export const fullscreenIsAvailable = () => !!root.requestFullscreen || !!root.webkitRequestFullscreen;

export const isFullscreen = () => !!webkitDocument.fullscreenElement || webkitDocument.webkitIsFullScreen;

export const openFullScreen = (): Promise<void> | void => {
  if (root.requestFullscreen) return root.requestFullscreen();
  else if (root.webkitRequestFullscreen) root.webkitRequestFullscreen();
};

export const closeFullScreen = (): Promise<void> | void => {
  if (webkitDocument.exitFullscreen) return webkitDocument.exitFullscreen();
  else if (webkitDocument.webkitExitFullscreen) webkitDocument.webkitExitFullscreen();
};

const webkitDocument = document as Partial<Document> & {
  webkitExitFullscreen?: () => void;
  webkitFullscreenElement?: Element | null;
  webkitIsFullScreen?: boolean;
};

const root = document.documentElement as Partial<HTMLElement> & { webkitRequestFullscreen?: () => void };
